import { graphql } from 'react-relay';

import { InternalUserPaginator_query$key } from '../../../relay/__generated__/InternalUserPaginator_query.graphql';
import FragmentPaginator, { FragmentPaginatorProps } from '../../core/FragmentPaginator';

const InternalUserPaginator_query = graphql`
  fragment InternalUserPaginator_query on Query
  @argumentDefinitions(
    filters: { type: MATInternalUserFilter }
    order: { type: MATInternalUserOrder }
    first: { type: Int }
    after: { type: String }
  )
  @refetchable(queryName: "InternalUserPaginatorRefreshQuery") {
    internalUsers(filters: $filters, order: $order, first: $first, after: $after)
      @connection(key: "InternalUserPaginator_query_internalUsers") {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          userName
          loginId
          userSequence
        }
      }
    }
  }
`;

type Props = {} & Omit<FragmentPaginatorProps<InternalUserPaginator_query$key>, 'fragment'>;

const InternalUserPaginator = ({ ...props }: Props) => <FragmentPaginator fragment={InternalUserPaginator_query} {...props} />;

export default InternalUserPaginator;
